export default __webpack_public_path__ + "static/media/login.9c1ecd37.jpg";